import Markdown from "markdown-to-jsx";
import * as React from "react";
import { FormField, IconButton, Input, Label, TextArea, useToast } from "uxp/components";
import { hasValue } from "../../../../util";
import { ContextDataAutoComplete } from "../../ContextDataAutoComplete";
import EditorComponent from "../../EditorComponent";
import { generateSchema } from "../../json-schema-tools";
import { ICustomJsonDataSource, IDataSource, IExternalDatabaseDataSource, IModelActionDataSource, IModelCollectionDataSource } from "../datasource";

interface IDataSourceEditorProps {
    source: IDataSource;
    onUpdated: (newSource: IDataSource) => void;
    onClose: () => void;
    contextData: any;
}

export const DataSourceEditor: React.FunctionComponent<IDataSourceEditorProps> = (props) => {
    let [currentSource, setCurrentSource] = React.useState<IDataSource>(props.source);
    let [editJson, setEditJson] = React.useState(true)

    const toast = useToast()

    React.useEffect(() => {
        console.log('currentSource ', currentSource);

    }, [currentSource])

    function save() {
        props?.onUpdated(currentSource);
    }

    function renderModelAction() {
        return <div className='dse-container'>
            <div className='dse-header'>
                <div className='icon' style={{ backgroundImage: `url(${currentSource?.icon})` }} />
                <div className='model'>{(currentSource as IModelActionDataSource)?.model}</div>
                <div className='action'>{(currentSource as IModelActionDataSource)?.action}</div>
            </div>
            <div className='dse-body'>
                <div className="dse-readme">
                    {

                        currentSource?.description ? <Markdown>{currentSource?.description}</Markdown> : <div className="nodata">{'This action does not have a description'}</div>
                    }
                </div>
                <div className='dse-inputs'>
                    <div className='tt'>{'Expected Inputs'}</div>
                    {
                        currentSource?.parameters?.map((p, i) => {
                            return <div className='dse-input'>
                                <label>{p.description}</label>
                                <ContextDataAutoComplete value={p.value || ''} onChange={(s) => {
                                    let parameters = currentSource?.parameters.slice();
                                    parameters[i].value = s;
                                    setCurrentSource(Object.assign({}, currentSource, { parameters }));
                                }}
                                    contextData={props.contextData}
                                />
                            </div>;
                        })
                    }
                    {
                        Number(currentSource?.parameters?.length) ? '' : <div className="no-data">No inputs expected</div>
                    }
                </div>
                <div className='saver' onClick={() => save()}>Save</div>
                {props.onClose && <div className='closer' onClick={() => props.onClose()}>{'←'}</div>}
            </div>
        </div>;
    }

    function renderJson() {
        return <div className='dse-container'>

            <div className="json-editor-container">
                <div className="row">
                    <FormField>
                        <Label>Name</Label>
                        <Input
                            value={(currentSource as ICustomJsonDataSource).name || ''}
                            onChange={s => setCurrentSource(Object.assign({}, currentSource, { name: s }))}
                        />
                    </FormField>

                    <FormField>
                        <Label>Description</Label>
                        <TextArea
                            value={currentSource.description || ''}
                            onChange={s => setCurrentSource(Object.assign({}, currentSource, { description: s }))}
                        />
                    </FormField>
                </div>

                <FormField>
                    <Label>JSON</Label>
                    <div className="json">

                        {!editJson &&
                            <div className="edit-btn-container">
                                <IconButton
                                    type={'edit'}
                                    onClick={() => setEditJson(true)}
                                />
                            </div>
                        }

                        {editJson ?
                            <EditorComponent
                                value={JSON.stringify((currentSource as ICustomJsonDataSource).json || {})}
                                onSave={s => new Promise((done, nope) => {
                                    try {
                                        let jObject = JSON.parse(s)

                                        // generate the schema
                                        let schema = generateSchema(jObject)

                                        setCurrentSource(Object.assign({}, currentSource, { json: jObject, schema: schema }))
                                        done('done')
                                        setEditJson(false)
                                    }
                                    catch (e) {
                                        toast.error('JSON is invalid')
                                        nope(e)
                                    }
                                })}
                                onCancel={() => { setEditJson(false) }}
                                language={'json'}
                            />
                            :
                            <pre>
                                <code>
                                    {JSON.stringify((currentSource as ICustomJsonDataSource).json || {}, null, 4)}
                                </code>
                            </pre>
                        }
                    </div>
                </FormField>
            </div>

            {!editJson &&
                <div className='saver' onClick={() => save()}>Save</div>
            }
            {hasValue(currentSource.id) && props.onClose &&
                <div className='closer' onClick={() => props.onClose()}>{'←'}</div>
            }
        </div>
    }

    if (currentSource.type == 'model-action') return renderModelAction()
    else if (currentSource.type == 'custom-json') return renderJson()
    else if (currentSource.type == 'model-collection') return <div> Comming soon</div>
    else return <div>Invalid Type</div>
};